import styled from "styled-components";
import { colors } from "healthex-common/colors";
import Language from "@mui/icons-material/Language";
export const TranslationsWizardLanguageIcon = styled(Language) `
    color: ${colors.black_lighter};
    width: 24px;
    height: 24px;
`;
